<template>
    <div
        v-loading="loadingQrSign"
        element-loading-text="签署中，请稍后..."
    >
        <div
            class="sign-container"
            :class="{'full-screen': signSource === 'ZWDT_OPEN', 'iframe-container': hideFrame}"
        >
            <template>
                <div class="header">
                    <div class="header-ctrl">
                        <el-button
                            class="grey-text small-font"
                            type="text"
                            v-if="signSource !== 'ZWDT_OPEN'"
                            @click="$router.back()"
                        >&lt; 返回上一页</el-button>
                    </div>
                    <h4 class="text-center">文件电子印章</h4>
                    <div class="header-ctrl text-right">
                        <template v-if="signStatus && signStatus !== 'SIGNING'">
                            <el-button
                                v-if="canDownload"
                                type="primary"
                                icon="el-icon-download"
                                @click="downloadContract(contract.id)"
                            > 下载</el-button>
                        </template>
                        <el-button
                            type="primary"
                            v-else
                            @click="doConfirmSign()"
                        >完成签署</el-button>
                    </div>
                </div>
                <div
                    class="contract-sign"
                    :class="{'height-adjust': signStatus && signStatus !== 'SIGNING'}"
                >
                    <div
                        class="contract-seal"
                        v-if="signStatus == 'SIGNING'"
                    >
                        <sign-menu
                            v-bind="{
                                loadingSeal,
                                signType,
                                sealName,
                                quser,
                                imageUrl,
                                personalSeal,
                                rectangles,
                                hasUkey,
                                verify,
                                sealSpec,
                                qrCode,
                                hasSeal,
                                visiblePreviewQr: true, // open 接口不能显示 点击添加二维码
                                isPDF,
                                isZWFWSEAL,
                                hasRegisterNo,
                                isEtlType,
                                timeStampControlAdd,
                                licenseNo: contract.licenseNo,
                            }"
                            @changeDatePattern="changeDatePattern"
                            @getAnnotationQrCode="getAnnotationQrCode"
                            @scrollTo="locateAppoint"
                        ></sign-menu>

                        <div class="menu-footer grey-text">
                            上海市电子印章公共服务平台 <br>
                            客服电话：<span class="red-text">021-962600</span>
                        </div>
                    </div>

                    <div class="contract-container">
                        <qys-pdf-viewer
                            v-if="url"
                            ref="qys-pdf-viewer"
                            v-bind="{ currentDocument , documents, url, pdfRenderMode }"
                            :dimensions="currentDocument.page"
                            @document-rendered="onDocumentRendered"
                            @on-drag-over="onDragOver"
                            @on-drag-leave="onDragleave"
                            @scale-change="doScaleChange"
                            @on-drop="onDrop"
                        >
                            <template #default="{ pageNumber, scale, dimensions }">
                                <div
                                    class="qr-code"
                                    v-if="visiblePreviewQr && pageNumber === 1 && contract.status !== 'COMPLETE'"
                                >
                                    <img :src="qrCodeImg">
                                    <i
                                        class="el-icon-error"
                                        @click="visiblePreviewQr = false"
                                    ></i>
                                </div>
                                <!-- 接口指定的签署位置 -->
                                <appoint-location
                                    v-bind="{
                                        pageNumber,
                                        rectangles,
                                        sealUrl,
                                        datePattern,
                                        verify,
                                        isPersonal,
                                        isPDF,
                                        isZWFWSEAL,
                                        isEtlType,
                                        sealId,
                                        page: currentDocument.page[pageNumber - 1],
                                        originPointer: isPDF ? 'LB' : 'LT',
                                    }"
                                    @resetStamperAndRectangles="resetStamperAndRectangles"
                                ></appoint-location>
                                <!-- 拖拽位置 -->
                                <template v-for="(stamper, stamperIndex) in signLocations">
                                    <SignStamper
                                        ref="stampers"
                                        v-if="stamper.page === pageNumber || isAcross(stamper)"
                                        :page="currentDocument.page[pageNumber - 1]"
                                        :key="getStamperKey(stamper, stamperIndex)"
                                        :index="stamperIndex"
                                        :stamper="stamper"
                                        :originPointer="isPDF ? 'LB' : 'LT'"
                                        :signStampers.sync="signLocations"
                                        @deleteCover="deleteCover"
                                        @resetStamperAndRectangles="resetStamperAndRectangles"
                                    ></SignStamper>
                                </template>
                            </template>
                        </qys-pdf-viewer>
                    </div>
                </div>
            </template>

            <send-message
                :visible.sync="sendMessage"
                v-if="sendMessage"
                :contact="contact"
                @onConfirm="doConfirmSign"
                title="确认签署"
            ></send-message>

            <!-- ukey签署 -->
            <ukey-password-confirm
                :visible.sync="visibleUkey"
                v-if="visibleUkey"
                @onConfirm="handlePreSign"
            ></ukey-password-confirm>

            <qrcode-sign-modal
                :visible.sync="visibleQrCode"
                :locations="locations"
                :zwdt_access_token="zwdt_access_token"
                v-if="visibleQrCode"
            ></qrcode-sign-modal>
            <el-dialog
                custom-class="qr-dialog"
                title=""
                :visible.sync="waitingSigningOpts.vis"
                width="300px"
                :before-close="waitingSigningDialogClose">
                <p class="qr-tip">{{isLpMiniAppSign ? '请使用”法人一证通小程序”扫码确认签署' :  waitingSigningOpts.title }}</p>
                <div class="qr-content">
                    <img class="qr-img"  :src="waitingSigningOpts.qrCodeImg" />
                    <div class="expire-img clearfix" v-if="isExpire">
                        <p class="expire-tips">二维码已过期请刷新后重试</p>
                        <el-button @click="doRefresh" size="mini" type="primary" :loading="isLoading">刷新</el-button>
                    </div>
                </div>
                <p class="expire-time">过期时间：{{ waitingSigningOpts.seconds }}</p>
            </el-dialog>
        </div>
        <el-dialog
            title=""
            :visible.sync="vis"
            width="500px"
            :before-close="handleDialogBeforeClosed"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            custom-class="custom-dialog"
            @open="handleDialogOpened"
        >
            <p class="count-down-desc">倒计时：{{ remainingTimeDesc }}</p>
            <p v-for="tip in signTip" :key="tip">
                <span v-html="tip"></span>
            </p>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import qs from 'qs';
import SignStamper from './childs/sign-stamper';
import SignMenu from "./childs/sign-menu.vue";
import AppointLocation from './childs/rectangles.vue';
import SendMessage from './childs/send-message.vue';
import UkeyPasswordConfirm from './childs/ukey-password-confirm.vue';
import QrcodeSignModal from './childs/qrcode-sign-modal.vue';
import { keyType, keyUsage } from "../../components/ukey/keyModel";
import BrowserUtils from '../../assets/utils/browser';
import QysPdfViewer from '@/components/qys-pdf-viewer';
import axios from "axios";

export default {
    name: "app",

    components: {
        SignStamper,
        QysPdfViewer,
        SignMenu,
        AppointLocation,
        SendMessage,
        QrcodeSignModal,
        UkeyPasswordConfirm
    },

    data () {
        return {
            etlSignSource: null,
            animationId: null,
            remainingTimeDesc: '50秒',
            sealName: '',
            timer: '',
            qrCode: '',
            hasSeal: false,
            visibleQrCode: false,
            pin: '',
            loadingSeal: true,
            loadingPdf: null,
            verify: false, // 印章是否有效
            url: '', // pdf文件路径
            contract: {}, // 文件详情
            digest: '', // 签署摘要
            sm2digest: '', //sm2 摘要
            signKey: '', // 签署key 值
            signAlg: '', // 签名算法类型 :string = SM2 | RSA
            signLocations: [], // 签署位置
            locations: [], // 请求二维码签章数据
            rectangles: [], // 指定签章位置
            documents: [], // 文档信息
            currentDocument: {}, // 当前签署文档
            imageUrl: '', // 法人印章图片
            personalSeal: '', // 个人印章图片
            datePattern: 'SECONDARY_THIRD', // 时间戳格式
            signData: '', // 签署数据
            sm2SignData: '', // sm2 签署数据
            hasUkey: false,
            visibleUkey: false,
            sendMessage: false,
            qrCodeSetInterval: null,
            loadingQrSign: false,
            intervalNum: 0,
            isLoading: false,
            sealSpec: {
                width: 42,
                height: 42
            },
            // current page cert sm2Cert
            currentCert: '',
            sm2Cert: '',
            sealId: '',
            vis: false,
            waitingSigningOpts: {
                vis: false,
                timer: 0,
                seconds: 90,
                qrCodeImg: '',
                title: '请使用”企业云”APP扫码确认签署',
            },
            qrCodeImg: '',
            visiblePreviewQr: false,
            annotations: [
                {
                    position: "UPPER_LEFT", //位置信息 UPPER_LEFT:左上 UPPER_RIGHT:右上 LOWER_LEFT:左下  LOWER_RIGHT:右下
                    type: "QRCODE",         //批注类型 QRCODE:二维码类型
                    alpha: 255
                }
            ],
            isZWFWSEAL: false,
            sealInfo: {},
            hasRegisterNo: true,
            source: null,
            eltQrKey: '',
        };
    },
    inject: ['app'],
    provide () {
        return {
            signPage: this
        };
    },
    async mounted () {
        document.getElementById('app').classList.add('adjust-height');
        await this.getContractDetail();
        this.isEtlType && this.getEtlSeal();
    },
    computed: {
        ...mapGetters(['isEtl']),
        pdfRenderMode () {
            return (!this.isPDF || BrowserUtils.isIE())
                ? 'IMAGE'
                : 'STREAM';
        },
        // 文档ID
        documentId () {
            return this.currentDocument?.id;
        },
        cert () {
            return this.app && this.app.cert || '';
        },
        // sm2Cert () {
        //     return this.app && this.app.sm2Cert || '';
        // },
        openApi () {
            return '';
        },
        // token 秘钥
        zwdt_access_token () {
            return this.$route.query.zwdt_access_token;
        },
        // 签署来源
        signSource () {
            return this.$route.query.signSource;
        },
        quser () {
            return this.$store.getters.quser;
        },
        isPersonal () {
            return this.signType === "PERSONAL_PIN";
        },
        isQrCodeSign () {
            return this.signType === "SEAL_QRCODE";
        },
        isCompanySign () {
            return this.signType === "SEAL_PIN";
        },
        // 是否是UKEY签署
        isUkeySign () {
            return ["SEAL_UKEY", 'SEAL_UKEY_PERSON'].includes(this.signType);
        },
        isEtlSign () {
            return ['SEAL_ETL', 'OUTER_SEAL_ETL', 'ECLOUD_SIGN'].includes(this.signType) && this.authType !== 'ETL_QR';
        },
        isEcloudSign() {
            return this.signType === 'ECLOUD_SIGN';
        },
        isLpMiniAppSign() {
            return this.signType === 'LPMINIAPP_SIGN';
        },
        isEQrSign() {
            return this.authType === 'ETL_QR';
        },
        signTip() {
            //return ['请前往“电子营业执照”<b>微信小程序</b>-其他应用-电子投标-上海-政府采购网-标书签章-签章 完成签署'];
             const signTipMap = {
                 OUTER_SEAL_ETL: '-其他应用-电子投标-上海-政府采购网-标书签章-签章 完成签署',
                 SEAL_ETL: '-上海专区-电子印章-使用印章-电子签章 完成签署',
             };
             return ['请前往“电子营业执照”<b>微信小程序</b>'].concat([signTipMap[this.signType]]);
        },
        // 签署类型
        authType () {
            return this.contract.authType || '';
        },
        signType () {
            return this.contract.signType || '';
        },
        currSignatory () {
            // return this.contract && this.contract.signatories && _.find(this.contract.signatories, item => item.id === this.contract.signatoryId) || {};
            return this.contract && this.contract.signatories && this.contract.signatories[0] || {};
        },
        hasAppointLocation () {
            return this.currSignatory.locations && this.currSignatory.locations.length;
        },
        contact () {
            // return this.currSignatory.contact || '';
            return this.currSignatory.contact || {};
        },
        // 是否能下载
        canDownload () {
            return this.contract.download || false;
        },
        //是否可以添加时间戳
        timeStampControlAdd() {
            return this.contract?.timeStampControlAdd;
        },
        // 是否存在骑缝章
        hasAcrossSeal () {
            return this.rectangles.some(rect => rect.rectType == 'ACROSS_PAGE')
                || this.signLocations.some(rect => rect.rectType == 'ACROSS_PAGE');
        },
        sealUrl () {
            return this.isPersonal ? this.personalSeal : this.imageUrl;
        },
        signStatus () {
            return this.contract && this.contract.status;
        },
        isReady () {
            return this.app.sealData && !this.isPersonal && this.app.picData && this.isUkeySign;
        },
        hideFrame () {
            return this.$route.query.hideFrame && this.$route.query.hideFrame !== 'false';
        },
        // etl 只能拖一个章
        etlHasSeal () {
            return this.signLocations && this.signLocations.filter(item => item.rectType !== 'ACROSS_PAGE').length;
        },
        isEtlType () {
            // 登录状态与非登录状态
            return this.isEtl || this.isEtlSign || this.isEQrSign;
        },
        isPDF () {
            const fileType = this.currentDocument && this.currentDocument.type;
            return ['PDF', 'pdf'].includes(fileType);
        },
        isOriginLB () {
            return this.isPDF ? true : false;
        },
        isExpire() {
            return this.waitingSigningOpts.seconds === 0;
        }
    },
    watch: {
        isReady: {
            handler (nv) {
                if (nv) {
                    this.hasUkey = true;
                    this.getLpSignInfo();
                }
            },
            immediate: true
        },
        signType: {
            handler (nv) {
                if (nv && (this.isPersonal || this.isQrCodeSign)) {
                    this.isPersonal && this.getQrCode();
                    this.handerQrInterval();
                }
            },
            immediate: true
        },
        'app.cert': {
            handler (nv) {
                this.hasUkey = !!nv;
            },
            immediate: true
        },
        "signLocations.length": {
            handler (nv) {
                if (nv) {
                    this.$set(this.signLocations[nv - 1], 'active', true);
                }
            }
        }
    },

    methods: {
        handleDialogOpened() {
            // requestAnimationFrame 倒计时50s
            const endTime = Date.now() + 50 * 1000;
            const step = (timestamp) => {
                const diff = endTime - Date.now();
                if (diff > 0) {
                    this.remainingTimeDesc = `${Math.floor(diff / 1000)}秒`;
                    this.animationId = window.requestAnimationFrame(step)
                }
                if (diff <= 0){
                    this.etlSignSource?.cancel?.('[签署超时！建议重新点击“完成签署”]');
                }
            }
            window.requestAnimationFrame(step);
        },
        handleDialogBeforeClosed() {
            this.vis = false
            if (this.animationId) {
                cancelAnimationFrame(this.animationId);
                this.animationId = null;
            }
            this.etlSignSource?.cancel?.('[签署超时！建议重新点击“完成签署”]');
        },
        locateAppoint (index) {
            let rectangle = this.rectangles[index - 1];
            const page = parseInt(rectangle.page);
            const viewer = this.$refs['qys-pdf-viewer'];
            const { top = 0, height = 0 } = viewer?.pagePositionConfigs.positions?.[page - 1] ?? {};
            const actualHeight = height * (1 - rectangle.offsetY - rectangle.height);
            this.$nextTick(() => {
                viewer?.updateScrollTop?.(top + actualHeight);
            });
        },
        isAcross (stamper) {
            return ['ACROSS_PAGE', 'ACROSS_PAGE_ODD'].includes(stamper.rectType);
        },
        // 生成唯一key
        getStamperKey (stamper, index) {
            !stamper.uniqueKey && (stamper.uniqueKey = `${stamper._id}${Math.random()}${index}`);
            return stamper.uniqueKey;
        },
        getEtlSeal () {
            this.hasUkey = true;
            this.verify = true;
            if (this.signSource === 'ZWDT_OPEN') {
                this.getOpenSeal();
            } else {
                this.loadingSeal = false;
                const seal = JSON.parse(sessionStorage.selectedSeal);
                this.sealSpec.height = seal.specHeight;
                this.sealSpec.width = seal.specWidth;
                this.sealId = seal.id;
                this.imageUrl = `data:image/png;base64,${seal.sealPic}`;
                this.sealName = seal.sealName;
            }

        },
        async getOpenSeal () {
            try {
                this.loadingSeal = false;
                const { code, result, message } = (await this.axios.get('/zwdt/view/getseal', {
                    params: { zwdt_access_token: this.zwdt_access_token },
                }, {
                    headers: { zwdt_access_token: this.zwdt_access_token },
                }) || {}).data;
                if (code === 0) {
                    this.imageUrl = `data:image/png;base64,${result.data}`;
                    this.sealSpec.height = result.spec.height;
                    this.sealSpec.width = result.spec.width;
                    this.sealId = result.id;
                    this.sealName = result.name;
                } else {
                    this.$message.error(message);
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.loadingSeal = false;
            }
        },

        // 签署位置对象
        Rectangle () {
            return {
                createTime: this.Utils.formatDate(new Date()),
                documentId: this.documentId,
                contractId: this.contract.id,
                signatoryId: this.currSignatory.id,
                rectType: '',
                page: 1,
                width: 42,
                height: 42,
                _id: this.Utils.getUid(),
                active: true,
                offsetX: 0,
                offsetY: 0,
                src: '',
                style: {
                    width: 0,
                    height: 0,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    zIndex: 99
                },
                autoAddTimeStamperPosition: {
                    position: undefined,
                    offsetX: undefined,
                    offsetY: undefined,
                    src: undefined,
                    dimension: undefined,
                    originStyle: undefined,
                }
            };
        },

        handerQrInterval () {
            if (!this.qrCodeSetInterval) {
                this.qrCodeSetInterval = setInterval(this.checkSealStatus, 5000);
            }
        },

        /** 查询合同签署状态 */
        async handleContractStatus () {
            this.intervalNum = setInterval(async () => {
                await this.queryContractStatus();
            }, 3000);
        },

        /** 获取合同签署状态 */
        async queryContractStatus () {
            try {
                const { data } = await this.axios({
                    url: '/zwdt/view/get/contract/status',
                    headers: { zwdt_access_token: this.zwdt_access_token },
                    params: { zwdt_access_token: this.zwdt_access_token },
                });
                if (data.code === 0) {
                    const status = data.result;
                    if (status === 'SIGNING') {
                        this.loadingQrSign = true;
                        this.visibleQrCode = false;
                    }
                    if (status === 'COMPLETE') {
                        this.loadingQrSign = false;
                        this.getContractDetail();
                        clearInterval(this.intervalNum);
                    }
                    if (status === 'TIMEOUT') {
                        this.loadingQrSign = false;
                        this.visibleQrCode = false;
                        clearInterval(this.intervalNum);
                        this.$message.error('签署超时，请重试...');
                    }

                }
            } catch (error) {
                console.log('error: ', error);
                this.loadingQrSign = false;
            }
        },

        async checkSealStatus () {
            try {
                let resp = await this.axios({
                    url: `/zwdt/view/seal/exist`,
                    headers: { zwdt_access_token: this.zwdt_access_token },
                    params: { zwdt_access_token: this.zwdt_access_token },
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.hasSeal = resp.result;
                    if (resp.result) {
                        await this.getPersonalSeal();
                    } else {
                        this.loadingSeal = false;
                        this.hasSeal = false;
                    }
                } else {
                    this.loadingSeal = false;
                    this.hasSeal = false;
                }
            } catch (error) {
                console.log(error);
            }
        },

        async getQrCode () {
            this.qrCode = `${this.BASE_APP_PATH}/zwdt/view/seal/qr?zwdt_access_token=${this.zwdt_access_token}`;
        },

        async getCompanySeal () {
            try {
                this.getPersonalSeal();
            } catch (error) {
                console.log(error);
            }
        },

        /**
         * 获取个人印章
         */
        async getPersonalSeal () {
            try {
                let resp = await this.axios({
                    url: `/zwdt/view/seal`,
                    headers: { zwdt_access_token: this.zwdt_access_token },
                    params: { zwdt_access_token: this.zwdt_access_token },
                });
                resp = resp.data;
                if (resp.code == 0) {
                    this.loadingSeal = false;
                    if (this.isCompanySign || this.isQrCodeSign) {
                        this.imageUrl = `data:image/png;base64,${resp.image}`;
                    } else {
                        this.personalSeal = `data:image/png;base64,${resp.image}`;
                    }
                    if (this.isPersonal) {
                        if (resp.width > resp.height) {
                            this.sealSpec.height = 16;
                            this.sealSpec.width = 40;
                        } else {
                            this.sealSpec.height = 25;
                            this.sealSpec.width = 25;
                        }
                        // 自动盖章，仅针对创建 个人电子文档 开放接口生成的签署页面
                        if (this.contract.sealAutoAdd && this.rectangles.length && this.personalSeal) {
                            this.rectangles.forEach(rectangle => {
                                if (rectangle.rectType === 'SEAL_PERSONAL') {
                                    this.$set(rectangle, 'src', this.personalSeal);
                                }
                            });
                        }
                    } else {
                        this.sealSpec.height = 42;
                        this.sealSpec.width = 42;
                    }
                } else {
                    this.loadingSeal = false;
                    this.$message.error(resp.message);
                }
            } catch (error) {
                this.loadingSeal = false;
                console.log(error);
            }
        },

        /**
         * 印章有效性验证
         */
        async getSealVerify (requsetData) {
            this.loadingSeal = true;
            let resp = await this.axios({
                url: `/zwdt/view/seal/verify`,
                method: 'POST',
                params: { zwdt_access_token: this.zwdt_access_token },
                data: requsetData,
                headers: { zwdt_access_token: this.zwdt_access_token }
            });
            resp = resp.data;
            if (resp.code === 0) {
                this.isZWFWSEAL = resp.result.sealStructure === "ZWFWSEAL";
                if (resp.result.pic_data) {
                    this.sealInfo = resp.result;
                    this.verify = resp.result.seal_status === 1;
                    this.sealName = resp.result.seal_name;
                    this.imageUrl = `data:image/png;base64,${resp.result.pic_data}`;
                    this.sealSpec.height = resp.result.spec.height;
                    this.sealSpec.width = resp.result.spec.width;
                }
                this.loadingSeal = false;
            }
            else if (resp.code === 1200005) {
                this.loadingSeal = false;
                this.hasRegisterNo = false;
            } else {
                this.loadingSeal = false;
            }
        },

        updateCompleteButton (currentIndex, jump) {
            if (jump) return;
            this.signLocations.map((location, index) => {
                location.active = currentIndex == index;
            });
        },

        /**
         * 获取文件详情
         */
        async getContractDetail (noLoad) {
            let resp, loading;
            try {
                if (!noLoad) {
                    loading = this.$loading({
                        text: '努力加载中...'
                    });
                }
                resp = await this.axios({
                    url: this.openApi + '/zwdt/view/detail',
                    method: 'GET',
                    params: { zwdt_access_token: this.zwdt_access_token },
                    headers: { zwdt_access_token: this.zwdt_access_token }
                });
                resp = resp.data;
                resp.contract.docuemnts = resp.contract.documents.map(doc => {
                    doc.page = doc.page.map(page => {
                        const ZOOM_MM_IN = 595 / 210; // 英寸/mm 缩放比例
                        page.width = parseInt(page.pixelWidth / ZOOM_MM_IN);
                        page.height = parseInt(page.pixelHeight / ZOOM_MM_IN);
                        return page;
                    })
                    return doc;

                })
                this.contract = resp.contract;
                this.documents = resp.contract.documents;
                this.currentDocument = this.documents[0];
                this.url = '';
                this.$nextTick(() => {
                    if (this.signStatus === 'SIGNING') {
                        resp.contract.signatories.forEach(signatory => {
                            this.handleRectangles(signatory.locations);
                        });
                        // if (this.currSignatory.locations.length) {
                            // this.handleRectangles(this.currSignatory.locations);
                        // }
                        // 接口发起企业指定印章签署
                        if (this.isCompanySign || this.isQrCodeSign) {
                            this.hasUkey = true;
                            this.verify = true;
                            this.getCompanySeal();
                        }
                    } else {
                        this.rectangles = [];
                    }
                    this.rectangles?.forEach(rectangle => {
                        if (rectangle.rectType === 'TIMESTAMP') {
                            let originTimestampFormatType = rectangle.timestampFormatType;
                            // 有预设位置的时间戳格式不可更改，故添加字段标识
                            this.$set(rectangle, 'isAppointTimestampFormatType', !!originTimestampFormatType);
                            this.$set(rectangle, 'timestampFormatType', originTimestampFormatType || this.datePattern);
                            const { timestampFormatType, fontSize, fontType } = rectangle;
                            const src = this.getTimeStampImage(timestampFormatType, fontSize, fontType);
                            this.$set(rectangle, 'src', src);
                        }
                    });
                    this.sendMessage = false;
                    this.signLocations = [];
                    this.url = `${this.BASE_APP_PATH}/zwdt/view/document/download?documentId=${this.currentDocument.id}&zwdt_access_token=${this.zwdt_access_token}&cd=${Date.now()}`;
                });
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },

        changeDatePattern(pattern) {
            this.datePattern = pattern;
        },

        getTimeStampImage (formatType = 'SECONDARY_THIRD', fontSize, fontType) {
            const param = { formatType, fontSize, fontType, zwdt_access_token: this.zwdt_access_token || this.$route.query.zwdt_access_token };
            return `${this.BASE_APP_PATH}/seal/timestamp?${qs.stringify(param)}`;
        },

        /**
         * 处理指定签署位置
         */
        handleRectangles (rectangles) {
            this.rectangles.splice(0);
            rectangles.forEach(rectangle => {
                let label,
                    style;

                switch (rectangle.rectType) {
                    case ('SEAL_PERSONAL'):
                    case ('OPERATOR'):
                    case ('PERSONAL'):
                    case ('LEGAL_PERSON'):
                        label = '签名位置';
                        break;
                    case ('SEAL_CORPORATE'):
                        label = '签章位置';
                        break;
                    case ('ACROSS_PAGE'):
                    case ('ACROSS_PAGE_ODD'):
                        label = '骑缝章位置';
                        break;
                    case ('TIMESTAMP'):
                        label = '日期位置';
                        break;
                }

                style = {
                    width: rectangle.width * 100 + '%',
                    height: rectangle.height * 100 + '%',
                    position: 'absolute',
                    bottom: this.isOriginLB ? (rectangle.offsetY * 100 + '%') : ((1 - rectangle.offsetY) * 100 + '%'),
                    'z-index': 98,
                };

                if (rectangle.rectType == 'ACROSS_PAGE' || rectangle.rectType == 'ACROSS_PAGE_ODD') {
                    style.width = style.width * 0.5;
                    style.right = 0;
                    rectangle.page = 1;			// 指定的骑缝章放置到第一页
                } else {
                    style.left = rectangle.offsetX * 100 + '%';
                }

                rectangle.label = label;
                rectangle.style = style;

                this.rectangles.push(rectangle);
            });
        },

        /**
         * 文档加载结束后进行事件绑定
         */
        onDocumentRendered () {
            this.loadingPdf && this.loadingPdf.close();
        },
        doRefresh() {
            if (this.isLoading) {
               return;
            }

            this.isLoading = true;
            if(this.waitingSigningOpts.timer) {
                clearInterval(this.waitingSigningOpts.timer);
            }
            this.doConfirmSign();
        },
        async handleEqrSign(locations, pin) {
            let resp;
            try {
                if (this.source) {
                    this.source.cancel();
                }

                resp = await this.axios.post('/zwdt/view/etl/qrsign', {
                    locations,
                    pin,
                    key: this.eltQrKey,
                }, {
                    params: { zwdt_access_token: this.zwdt_access_token },
                    headers: {
                        zwdt_access_token: this.zwdt_access_token,
                    }
                });
                const { code, qrimage, message, key } = resp.data;
                if (code === 0) {
                    this.eltQrKey = key;
                    this.sendMessage = false;
                    this.waitingSigningOpts.title = '请使用”电子营业执照”*微信小程序*扫码确认签署';
                    this.waitingSigningOpts.vis = true;
                    this.waitingSigningOpts.qrCodeImg = `data:image/png;base64,${qrimage}`;
                    this.waitingSigningOpts.seconds = 60;
                    clearInterval(this.waitingSigningOpts.timer);
                    this.getEqrSignResult(key);
                    this.isLoading = false;
                    this.waitingSigningOpts.seconds = 60;
                    this.waitingSigningOpts.timer = setInterval(() => {
                        this.waitingSigningOpts.seconds--;
                        if (this.waitingSigningOpts.seconds === 0) {
                            clearInterval(this.waitingSigningOpts.timer);
                            this.source && this.source.cancel();
                        }
                    }, 1000);
                } else {
                    this.eltQrKey = '';
                    this.$message.error(message);
                }
            } catch (e) {
                this.eltQrKey = '';
                console.log(e);
            }
        },
        async getEqrSignResult(key) {
            let resp;
            try {

                const CancelToken = this.axios.CancelToken;
                this.source = CancelToken.source();

                resp = await this.axios.post('/zwdt/view/etl/signresult', qs.stringify({key}), {
                    cancelToken: this.source.token,
                    params: { zwdt_access_token: this.zwdt_access_token },
                    headers: {
                        zwdt_access_token: this.zwdt_access_token,
                    }
                });
                const { code, complete, message } = resp.data;
                if (code === 0) {
                    if (complete) {
                        this.$message.success('签署成功');
                        this.waitingSigningDialogClose();
                        clearInterval(this.waitingSigningOpts.timer);
                        this.getContractDetail(true);
                    }
                } else {
                    this.$message.error(message);
                }
                this.source = null;
            } catch (e) {
                console.log(e);
            }
        },
        /**
         * 企业云签署
         */
        async handleEcloudSign (locations, pin) {
            let resp;
            try {

                if (this.source) {
                    this.source.cancel();
                }

                resp = await this.axios.post('/mobilecert/opensign', {
                    locations,
                    pin,
                }, {
                    params: { zwdt_access_token: this.zwdt_access_token },
                    headers: {
                        zwdt_access_token: this.zwdt_access_token,
                    }
                });
                const { code, qrimage, message, key } = resp.data;
                if (code === 0) {
                    this.sendMessage = false;
                    this.waitingSigningOpts.vis = true;
                    this.waitingSigningOpts.qrCodeImg = `data:image/png;base64,${qrimage}`;
                    this.waitingSigningOpts.seconds = 60;
                    clearInterval(this.waitingSigningOpts.timer);
                    this.getEcloudSignResult(key);
                    this.isLoading = false;
                    this.waitingSigningOpts.seconds = 60;
                    this.waitingSigningOpts.timer = setInterval(() => {
                        this.waitingSigningOpts.seconds--;
                        if (this.waitingSigningOpts.seconds === 0) {
                            clearInterval(this.waitingSigningOpts.timer);
                            this.source && this.source.cancel();
                        }
                    }, 1000);
                } else {
                    this.$message.error(message);
                }
            } catch (e) {
                console.log(e);
            }
        },
        async getEcloudSignResult(key) {
            let resp;
            try {

                const CancelToken = this.axios.CancelToken;
                this.source = CancelToken.source();

                resp = await this.axios.post('/mobilecert/sign/result', qs.stringify({key}), {
                    cancelToken: this.source.token,
                    params: { zwdt_access_token: this.zwdt_access_token },
                    headers: {
                        zwdt_access_token: this.zwdt_access_token,
                    }
                });
                const { code, complete, message } = resp.data;
                if (code === 0) {
                    if (complete) {
                        this.$message.success('签署成功');
                        this.waitingSigningDialogClose();
                        clearInterval(this.waitingSigningOpts.timer);
                        this.getContractDetail(true);
                    }
                } else {
                    this.$message.error(message);
                }
                this.source = null;
            } catch (e) {
                console.log(e)
            }
        },
        async handleEtlSign (locations, pin) {
            let resp;
            try {
                // loading = this.$loading({
                //     text: '签署中...'
                // });
                this.waitingSigning();
                const CancelToken = axios.CancelToken;
                this.etlSignSource = CancelToken.source();
                resp = await this.axios.post('/zwdt/view/sign/etl', {
                    locations,
                    pin,
                }, {
                    params: { zwdt_access_token: this.zwdt_access_token },
                    headers: {
                        zwdt_access_token: this.zwdt_access_token,
                    },
                    cancelToken: this.etlSignSource.token,
                })
                if (resp.data.code === 0) {
                    // loading && loading.close();
                    if (resp.data.successPage) {
                        this.jumpToSuccessPage(resp.data.successPage, resp.data.preview);
                    }
                    this.getContractDetail(true);
                    this.sendMessage = false;
                    // this.waitingSigningOpts.vis = true;
                    // this.waitingSigningOpts.seconds = 90;
                    // clearInterval(this.waitingSigningOpts.timer);
                    // this.waitingSigningOpts.timer = setInterval(() => {
                    //     this.waitingSigningOpts.seconds--;
                    //     if (this.waitingSigningOpts.seconds === 0) {
                    //         this.waitingSigningOpts.vis = false;
                    //         clearInterval(this.waitingSigningOpts.timer);
                    //         this.$message.error('签署超时');
                    //     }
                    // }, 1000);
                    // if (resp.data.code === 0 ){
                    //     // loading && loading.close();
                    //     location.reload();
                } else {
                    this.vis && this.$message.error(resp.data.message);
                }
            } catch (e) {
                if (axios.isCancel(e)) {
                    this.vis && this.$message.error(e.message);
                    console.warn('签署超时，取消请求', e.message);
                } else {
                    console.log(e);
                }
            } finally {
                this.vis = false;
                // clearInterval(this.waitingSigningOpts.timer);
                // this.waitingSigningOpts.vis = false;
                // loading && loading.close();
            }
        },
        waitingSigning () {
            this.vis = true;
        },
        // clearInterval(this.waitingSigningTimer);
        // this.$alert('<p style="height:150px;line-height:150px;text-align:center;">请前往“电子营业执照”微信小程序完成签署<p>', '', {
        //     showConfirmButton: false,
        //     beforeClose: (action, instance, done) => {
        //         // clearInterval(this.waitingSigningTimer);
        //         this.$message.error('签署失败');
        //         done();
        //     }
        // });
        // this.waitingSigningTimer = setInterval(() => {
        //     this.queryContractStatus();
        // }, 2000);
        // setInterval(() => {
        //     clearInterval(this.waitingSigningTimer);
        //     this.$message.error('签署失败');
        //     window.location.reload();
        // });
        waitingSigningDialogClose () {
            if (this.source) {
                this.source.cancel();
            }
            this.waitingSigningOpts.vis = false;
        },

        /**
         * 个人签署
         */
        async handlePersonalSign (locations, pin) {
            let resp, loading;
            try {
                loading = this.$loading({
                    text: '签署中...'
                });
                let url = '/zwdt/view/sign/personal';
                if (this.isCompanySign) {
                    url = `/zwdt/view/sign/company`;
                }
                let data = { locations, pin };
                if (this.visiblePreviewQr) {
                    data.annotations = this.annotations;
                }
                resp = await this.axios({
                    url: this.openApi + url,
                    method: 'POST',
                    data,
                    headers: { zwdt_access_token: this.zwdt_access_token },
                    params: { zwdt_access_token: this.zwdt_access_token }
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.$message.success('签署成功');
                    if (resp.successPage) {
                        this.jumpToSuccessPage(resp.successPage, resp.preview);
                    }
                    this.getContractDetail(true);
                    this.sendMessage = false;
                } else {
                    this.$message.error(resp.message);
                }
                console.log(resp);
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },

        // Ukey 配置
        async getLpSignInfo () {
            try {
                let requsetData = new FormData();
                requsetData.append('sealData', this.app.sealData);
                requsetData.append('old', this.app.isOld);
                requsetData.append('picData', this.app.picData);
                requsetData.append('cert', this.cert);
                await this.getSealVerify(requsetData);
            } catch (err) {
                this.hasUkey = false;
                console.log(err);
            }
        },

        /**
         * 法人签署
         */
        async handleLpSign (locations) {
            let loadingError;
            try {
                // 上传签名信息获取摘要
                // 调用/start/sign/lp 获取sm1 sm2 digest
                /**
                 * this.sm2digest = resp.sm2digest;
                 * this.signKey = resp.key;
                 * this.signIndex = resp.index;
                 * this.signAlg = resp.signAlg;
                 */
                this.signLoop(locations);
            } catch (error) {
                if (error.code == '2181300449') {
                    // UKEY服务忙时禁止用户操作10s
                    loadingError = this.$loading({
                        text: 'UKEY服务忙，请稍后再试...'
                    });
                    setTimeout(() => {
                        loadingError && loadingError.close();
                    }, 10000);
                } else {
                    error.message && this.$message.error(error.message);
                }
                console.log(error);
            }
        },

        async getSignAbstract (locations, opts) {
            let resp, sealData;
            sealData = this.isZWFWSEAL ? 'sm2SealData' : 'rsaSealData';
            let data = {
                locations: locations,
                sealSn: this.sealInfo.seal_sn,
                seal: this.imageUrl.split(',')[1],
                cert: this.cert,
                sm2Cert: this.sm2Cert,
                [sealData]: encodeURIComponent(this.sealInfo.sealData),
            };
            if (this.visiblePreviewQr) {
                data.annotations = this.annotations;
            }
            resp = await this.axios({
                url: this.openApi + '/zwdt/view/start/sign/lp',
                method: 'POST',
                data,
                params: { zwdt_access_token: this.zwdt_access_token },
                headers: { zwdt_access_token: this.zwdt_access_token }
            });
            resp = resp.data;
            // sm2digest key index  signAlg: SM2 RSA
            // if SM2 -> /sm2/sign/lp else -> /rsa/sign/lp
            // this.digest = resp.digest;
            opts.digest = resp.digest;
            opts.key = resp.key;
            opts.index = resp.index;
            opts.signAlg = resp.signAlg;
            // 可能有错误
            return resp;
        },

        /**
         * 获取ukey 签署数据
         */
        async doSignByUkey (opts) {
            const isRSA = opts.signAlg === 'RSA';
            console.log("doSignByUkey -> isRSA", opts.signAlg);
            const paramsData = isRSA ? {
                data: opts.digest,
                pwd: this.pin,
                algid: 4,
                isHex: true
            } : {
                    data: opts.digest,
                    pwd: this.pin,
                    asymid: keyType.K_SHCA_ASYMID_SM2,
                    algid: 4,
                    isHex: true
                };
            if (this.Utils.isIE()) {
                if (isRSA) {
                    await this.app.ukey.initService(this.pin);
                } else {
                    await this.app.ukey.initSm2Service(this.pin);
                }
            }
            let resp = await this.app.ukey.sign(paramsData);
            opts.signData = resp.result;
            // console.log('取到的sign 数据,opts.signData', opts.signData);
        },
        async signLoop (locations) {
            // doSignByUkey 获取摘要签名
            // /zwdt/view/sign 发送rsa数据，并获取判断是否结束签名，否则获取下一个签名的sm2 摘要
            // 循环
            let endLoop = false;
            // 签名数据
            let opts = {
                index: '',
                key: '',
                signAlg: '',
                digest: '',
                // sm2digest: '',
                signData: '',
            };
            let loading = this.$loading({
                text: '加载中...'
            });
            try {
                if (BrowserUtils.isIE()) {
                    // console.log('is ie ，sign 页面初始化获取证书');
                    // 初始化，获取两个证书
                    await this.app.ukey.initService(this.pin);
                    let cert = await this.app.ukey.getCert();
                    this.currentCert = encodeURIComponent(cert.result);
                    // console.log('app cert', this.cert);
                    // console.log('sign cert', this.currentCert);
                    await this.app.ukey.initSm2Service(this.pin);
                    // console.log('开始取 sm2 证书');
                    let sm2Cert = await this.app.ukey.getCert(keyType.K_SHCA_ASYMID_SM2, keyUsage.K_SHCA_USAGE_SIGN);
                    this.sm2Cert = encodeURIComponent(sm2Cert.result);
                    // console.log('sm2Cert', this.sm2Cert);
                } else {
                    let sm2Cert = await this.app.ukey.getCert(keyType.K_SHCA_ASYMID_SM2, keyUsage.K_SHCA_USAGE_SIGN);
                    this.sm2Cert = encodeURIComponent(sm2Cert.result);
                    // console.log('sm2Cert', this.sm2Cert);
                }

                const resp = await this.getSignAbstract(locations, opts);
                if (resp.code === 0) {
                    while (!endLoop) {
                        await this.doSignByUkey(opts);
                        const res = await this.sign(opts);

                        if (!res) {
                            //
                            endLoop = true;
                            console.log('error', res);
                        } else if (res.complete) {
                            endLoop = true;
                            this.$message.success('签署成功');
                            if (res.successPage) {
                                this.jumpToSuccessPage(res.successPage, res.preview);
                            }
                            this.getContractDetail(true);
                        } else {
                            opts.digest = res.digest;
                            opts.key = res.key;
                            opts.index = res.index;
                            opts.signAlg = res.signAlg;
                        }
                    }
                } else {
                    this.$message.error(resp.message);
                }
            } catch (e) {
                console.log(e);
                if (typeof e === 'string') {
                    this.$message.error(e);
                } else if (e && e.message) {
                    this.$message.error(e.message);
                }
            } finally {
                loading.close();
            }
        },
        async sign (opts) {
            let res = await this.axios({
                url: this.openApi + '/zwdt/view/sign',
                method: 'POST',
                data: {
                    pwd: this.pin,
                    key: opts.key,
                    index: opts.index,
                    cert: this.cert,
                    digest: opts.digest,
                    signAlg: opts.signAlg,
                    base64SignedData: opts.signData,
                },
                params: { zwdt_access_token: this.zwdt_access_token },
                headers: { zwdt_access_token: this.zwdt_access_token }
            });
            res = res.data;
            if (res.code === 0) {
                return res;
            } else {
                this.$message.error(res.message);
                return '';
            }
        },
        /**
         * 法人签署完成
         */
        async doSignLp () {
            let loading = this.$loading({
                text: '加载中...'
            });
            let resp;
            resp = await this.axios({
                url: this.openApi + '/zwdt/view/sign',
                method: 'POST',
                data: {
                    pwd: this.pin,
                    key: this.signKey,
                    base64SignedData: this.signData,
                    index: this.signIndex,
                    cert: this.cert,
                    sm2Cert: this.sm2Cert,
                    digest: this.digest,
                },
                params: { zwdt_access_token: this.zwdt_access_token },
                headers: { zwdt_access_token: this.zwdt_access_token }
            });
            resp = resp.data;
            loading.close();
            if (resp.code === 0) {
                if (resp.complete) {
                    this.$message.success('签署成功');
                    if (resp.successPage) {
                        this.jumpToSuccessPage(resp.successPage, resp.preview);
                    }
                    this.getContractDetail(true);
                } else {
                    // 如果签署未完成 则继续递归调用签署
                    this.digest = resp.digest;
                    this.sm2digest = resp.sm2digest;
                    this.signKey = resp.key;
                    this.signIndex = resp.index;
                    await this.doSignByUkey();
                    if (!this.signData) {
                        return;
                    }
                    await this.doSignLp();
                }
            } else {
                loading.close();
                this.$message.error(resp.message);
            }
        },

        /**
         * 删除签名块
         */
        deleteCover (index) {
            // 删除拖拽签名块
            this.signLocations.splice(index, 1);
        },

        resetStamperAndRectangles() {
            this.rectangles.forEach(item => this.$set(item, 'isClicked', false));
            this.signLocations.forEach(item => this.$set(item, 'isClicked', false));
        },

        /**
         * 签署前校验
         */
        handlePreSign (pin) {
            this.pin = pin;
            let locations = this.validateSignLocation();
            if (!locations) return;
            this.handleLpSign(locations);
        },

        validateSignLocation () {
            if (this.hasAppointLocation && this.rectangles.some(rect => !rect.src)) {
                this.$message.warning('请签署完所有指定签署位置！');
                return;
            }
            let locations = this.Utils.deepClone(this.signLocations) || [];
            if (this.hasAppointLocation) {
                locations = locations.concat(this.Utils.deepClone(this.rectangles));
            }
            locations = locations.map((location) => {
                Reflect.deleteProperty(location, 'style');
                Reflect.deleteProperty(location, 'src');
                Reflect.deleteProperty(location, 'label');
                Reflect.deleteProperty(location, '_id');
                return location;
            });
            if (!locations.filter(location => location.rectType !== 'ACROSS_PAGE' && location.rectType !== 'TIMESTAMP').length) {
                this.$message.warning(`请先添加签${this.isPersonal ? '名' : '章'}!`);
                return false;
            }
            return locations;
        },

        // 确认签署
        async doConfirmSign (pin) {
            this.pin = pin;
            let locations = this.validateSignLocation();
            if (!locations) return;
            // 企业云签署(一定要放在电照签署前)
            if (this.isEcloudSign) {
                this.handleEcloudSign(locations, pin);
                return;
            }
            if (this.isEQrSign) {
                this.handleEqrSign(locations, pin);
                return;
            }
            if (this.isEtlType) {
                this.handleEtlSign(locations, pin);
                return;
            }
            if (this.isPersonal || this.isCompanySign) {
                if (pin) {
                    await this.handlePersonalSign(locations, pin);
                } else {
                    this.sendMessage = true;
                }
            } else if (this.isUkeySign) {
                this.$confirm("是否确认签署当前文件", "操作提示", {
                    type: "warning"
                }).then(() => {
                    this.visibleUkey = true;
                });
            } else if (this.isQrCodeSign) { // 扫码签署
                this.locations = locations;
                this.visibleQrCode = true;
                this.handleContractStatus();
            }
        },

        downloadContract () {
            let data = {
                documentId: this.documentId,
                zwdt_access_token: this.zwdt_access_token
            };
            this.Utils.downloadByForm({
                action: `${this.url}`,
                method: "GET",
                params: data
            });
        },

        /**
         * 创建骑缝章
         */
        createAcrossPage (type, url, width, height) {

            if (this.hasAcrossSeal) {
                this.$message.warning('只能添加一个骑缝章！');
                return;
            }

            if (this.currentDocument.pages == 1) {
                this.$message.warning('单页文件不能添加骑缝章！');
                return;
            }

            const documentWidth = document.querySelector('.pdf-scroll-page').offsetWidth;
            const documentHeight = document.querySelector('.pdf-scroll-page').offsetHeight;
            // 横版
            let isHorizonal = documentWidth > documentHeight;
            const pageWidth = isHorizonal ? 297 : 210;
            const pageHeight = isHorizonal ? 210 : 297;

            let rect = this.Rectangle();
            this.isEtlType && (rect.sealId = this.sealId);
            rect.rectType = type;
            rect.url = url;
            rect.width = width / pageWidth;
            rect.height = height / pageHeight;
            rect.offsetX = documentWidth * (1 - rect.width) / documentWidth;
            rect.offsetY = 0.5;
            rect.src = url;
            rect.style = {
                width: rect.width * 100 + '%',
                height: rect.height * 100 + '%',
                position: 'absolute',
                left: rect.offsetX * 100 + '%',
                top: (1 - rect.offsetY) * 100 + '%',
                zIndex: 99
            };
            console.log('rect', rect)
            this.signLocations.push(rect);
        },

        /**
         * 取消元素dragover默认行为,使其可拖放
         */
        onDragOver (e) {
            e.preventDefault();
        },

        onDragleave () { },

        doScaleChange () { },

        /**
        * 鼠标释放,在拖放目标上接收数据并处理
        */
        onDrop (event, pageNo, documentWidth, documentHeight, bottom, type) {
            // 判断etl 是否已有签章
            // if (this.isEtlType && this.etlHasSeal) {
            //     this.$message.info('营业执照只能单签章');
            //     return;
            // }

            const { sealType, width: specWidth, height: specHeight, src, sealId } = JSON.parse(event.dataTransfer.getData('Text')) || {};

            const dimension = this.currentDocument.page[pageNo - 1];

            let width, height, styleWidth, styleHeight, x, y;
            let styleTop = event.offsetY;
            let styleLeft = event.offsetX;

            // 默认时间戳在A4纸下的尺寸
            const TIME_SPEC_WIDTH = 27.7;
            const TIME_SPEC_HEIGHT = 7.4;
            // 针对 印章类型 拖动在文档中显示尺寸设置
            switch (sealType) {
                case 'SEAL_PERSONAL_UKEY':
                case 'SEAL_CORPORATE':
                case 'SEAL_LP':
                case 'SEAL_PERSONAL':
                case 'SEAL_UKEY':
                case 'ACROSS_PAGE':
                    height = specHeight / dimension.height;
                    width = specWidth / dimension.width;
                    break;
                case 'TIMESTAMP':
                    height = TIME_SPEC_HEIGHT / dimension.height;
                    width = TIME_SPEC_WIDTH / dimension.width;
                    break;
            }

            styleWidth = width * 100;
            styleHeight = height * 100;
            x = styleLeft / documentWidth;

            y = (documentHeight - height * documentHeight - styleTop) / documentHeight;

            this.signLocations && this.signLocations.map(location => {
                location.active = false;
            });
            // 存储签名数据
            let rectangleData = this.Rectangle();
            rectangleData.rectType = sealType;
            rectangleData.page = pageNo;
            rectangleData.width = width;
            rectangleData.height = height;
            rectangleData.sealId = sealId;
            rectangleData.src = src;
            this.isEtlType && (rectangleData.sealId = this.sealId);

            // 时间戳需要设置格式
            if (rectangleData.rectType == 'TIMESTAMP') {
                rectangleData.timestampFormatType = this.datePattern;
            }

            // 左上角位置
            let LTPointerX = x - width / 2;
            let LTPointerY = 1 - y - height - height / 2;

            // 不带出时间戳修正最终坐标
            (LTPointerX < 0) && (LTPointerX = 0);
            (LTPointerX > 1 - width) && (LTPointerX = 1 - width);
            (LTPointerY < 0) && (LTPointerY = 0);
            (LTPointerY > 1 - height) && (LTPointerY = 1 - height);

            this.isOriginLB ?
                (rectangleData.offsetY = (1 - (LTPointerY + height))) :
                (rectangleData.offsetY = LTPointerY)
            rectangleData.offsetX = LTPointerX;

            // 处理带出时间戳位置判定
            if (!['ACROSS_PAGE', 'TIMESTAMP'].includes(sealType) && this.contract.signWithTime) {
                const timestampWidth = TIME_SPEC_WIDTH / dimension.width;
                const timestampHeight = TIME_SPEC_HEIGHT / dimension.height;

                let autoAddTimeStamp = {
                    bottom: true,
                    right: true,
                    left: true,
                }

                // 判定下面能不能放
                if (LTPointerY + timestampHeight + height > 1) {
                    autoAddTimeStamp.bottom = false;
                }

                // 判定右面能不能放
                if (LTPointerX + width + timestampWidth > 1) {
                    autoAddTimeStamp.right = false;
                }

                // 判定左面能不能放
                if (LTPointerX - timestampWidth < 0) {
                    autoAddTimeStamp.left = false;
                }

                let firstTrueKey = Object.keys(autoAddTimeStamp).find(key => autoAddTimeStamp[key]);
                // 时间戳图片
                const getTimeStampImage = (formatType = 'CHINESE_Y_M_D') => {
                    const param = {
                        formatType,
                        zwdt_access_token: this.zwdt_access_token || this.$route.query.zwdt_access_token
                    };
                    return `${this.BASE_APP_PATH}/seal/timestamp?${qs.stringify(param)}`;
                }

                if (firstTrueKey) {
                    // px高度
                    const timestampPixelWidth = timestampWidth * 100 * (documentWidth / 100);
                    const timestampPixelHeight = timestampHeight * 100 * (documentHeight / 100);

                    // 初始化原始数据
                    rectangleData.autoAddTimeStamperPosition = {
                        ...rectangleData.autoAddTimeStamperPosition,
                        src: getTimeStampImage(),
                        dimension,
                        originStyle: {
                            width: styleWidth + '%',
                            height: styleHeight + '%',
                        },
                        timeStamperStyle: {
                            width: timestampPixelWidth + 'px',
                            height: timestampPixelHeight + 'px',
                        }
                    }

                    const updatePositionData = (updateParams) => {
                        const { position, newStyleWidth, newStyleHeight, offsetX, offsetY } = updateParams;
                        styleWidth = newStyleWidth;
                        styleHeight = newStyleHeight;

                        rectangleData.autoAddTimeStamperPosition = {
                            ...rectangleData.autoAddTimeStamperPosition,
                            position,
                            offsetX,
                            offsetY,
                        };
                    };

                    switch (firstTrueKey) {
                        case 'bottom':
                            updatePositionData({
                                position: 'bottom',
                                newStyleWidth: styleWidth,
                                newStyleHeight: styleHeight + timestampHeight * 100,
                                offsetX: rectangleData.offsetX,
                                offsetY: rectangleData.offsetY - timestampHeight,
                            });
                            break;
                        case 'right':
                            updatePositionData({
                                position: 'right',
                                newStyleWidth: styleWidth + timestampWidth * 100,
                                newStyleHeight: styleHeight,
                                offsetX: rectangleData.offsetX + timestampWidth,
                                offsetY: rectangleData.offsetY + height / 2,
                            });
                            break;
                        case 'left':
                            LTPointerX -= timestampWidth; // 更新左侧起点
                            updatePositionData({
                                position: 'left',
                                newStyleWidth: styleWidth + timestampWidth * 100,
                                newStyleHeight: styleHeight,
                                offsetX: rectangleData.offsetX - timestampWidth,
                                offsetY: rectangleData.offsetY + height / 2,
                            });
                            break;
                    }
                }
            }

            rectangleData.style = {
                width: styleWidth + '%',
                height: styleHeight + '%',
                position: 'absolute',
                left: LTPointerX * 100 + '%',
                top: LTPointerY * 100 + '%',
                zIndex: 99
            };
            this.signLocations.push(rectangleData);
        },

        async getAnnotationQrCode () {
            this.visiblePreviewQr = true;
            this.axios({
                url: this.openApi + '/annotation/get/qrcode',
                method: 'GET',
                params: { contractId: this.contract.id, transparency: 255 }
            })
                .then((resp) => {
                    if (!resp.data.code) {
                        this.qrCodeImg = `data:image/png;base64,${resp.data.result}`;
                    }
                });

        },
    },
    created(){
    },
    beforeDestroy () {
        clearInterval(this.timer);
        clearInterval(this.qrCodeSetInterval);
        clearInterval(this.intervalNum);
        document.getElementById('app').classList.remove('adjust-height');
    },
};
</script>

<style lang="less">
.custom-dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 250px;
    .el-dialog__body {
        position: relative;
    }
    .count-down-desc {
        position: absolute;
        top: -10px;
        left: 140px;
        color: #ff0000;
    }
    p {
        text-align: center;
    }
}
#app.adjust-height {
    height: 100%;
}
.sign-container {
    &.iframe-container {
        min-height: 620px;

        .contract-sign {
            height: 100%;
        }

        .contract-seal {
            width: 200px;

            .seal-image {
                width: 160px;
            }
        }

        .pdf-thumbnail {
            img {
                border: 2px solid transparent !important;
            }
        }

        .pdf-viewer__preview {
            width: 180px;
            left: calc(100% - 180px);
        }
        .pdf-viewer__document.preview-enabled {
            width: calc(100% - 180px);
            right: 180px;
        }
    }

}
</style>

<style lang="less" scoped>
.sign-container {
    min-height: 800px;
    background: @background-color;

    .menu-footer {
        padding: 20px;
    }

    &.full-screen {
        height: 100vh;

        .contract-sign {
            height: calc(100vh - 90px);
        }
    }

    .rectangle {
        position: relative;
        border: 1px dashed @border-color-drak;
        background: rgba(188, 0, 0, 0.1);
        cursor: move;
        .delete-icon {
            position: absolute;
            display: block;
            background: @white;
            border-radius: 10px;
            top: -6px;
            right: -6px;
            cursor: pointer;
        }
        .stamper-image {
            position: absolute;
            top: 0;
            left: 0;
            max-width: none;
            height: 100%;
        }
    }

    .header {
        height: 60px;
        line-height: 60px;
        padding: 0 20px;
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: @white;
        box-shadow: 0 5px 5px 2px @black-opacity-1;
        border-top: 1px solid @border-color-base;

        .header-ctrl {
            width: 240px;
        }

        h4 {
            flex: 1;
        }
    }

    .contract-sign {
        display: flex;
        height: calc(100vh - 60px);
        background: @background-color;

        &.height-adjust {
            height: 1000px;
        }

        .contract-seal {
            min-width: 300px;
            height: 100%;
            // width: 30%;
            overflow: auto;

            display: flex;
            justify-content: space-between;
            flex-direction: column;
        }

        .contract-container {
            position: relative;
            flex: 1;
            background-color: #3c3c3c;
        }
    }
    .sign-button {
        position: absolute;
        bottom: -32px;
        right: -40px;
    }
    .across-page .sign-button {
        left: -40px;
    }
    .sign-footer {
        line-height: 80px;
        border-top: 1px solid @border-color-base;
    }
    .qr-code {
        position: absolute;
        top: 18px;
        left: 18px;
        z-index: 100;
        width: 41px;
        height: 41px;

        i {
            position: absolute;
            cursor: pointer;
            right: -5px;
            top: -5px;
        }
    }
}
.qr-dialog {
    .qr-tip {
        text-align: center;
        margin-bottom: 10px;
    }
    .expire-tips {
        margin: 25px;
    }
    .qr-content {
        position: relative;
        margin: 0 auto;
        width: 147px;
        color: @white;
    }
    .expire-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        text-align: center;
    }
    .expire-time {
        text-align: center;
        color: @red;
    }
}
</style>


